import IReader from './IReader'
import CommonBean from '../beans/CommonBean'
import { isArray } from 'util'

export default class CommonReader extends IReader {
    constructor() {
        super(CommonBean)
        this._format = new GeoGlobe.Format.GeoJSON()
    }

    /**
     * 读取通用Bean（geojson要素，GeoGlobe.Feature，GeoGlobe.Geometry）
     * @param {CommonBean} cbean
     */
    async _read(cbean) {
        let value = cbean.value
        // GeoGlobe.Feature
        if (value instanceof GeoGlobe.Feature) {
            value = [value]
        }
        // GeoGlobe.Geometry
        else if (value instanceof GeoGlobe.Geometry) {
            const f = new GeoGlobe.Feature(value)
            value = [f]
        }
        // Array
        else if (isArray(value)) {
            // do nothing
        }
        // geoJson格式
        else if (
            [
                'FeatureCollection',
                'Feature',
                'Point',
                'MultiPoint',
                'LineString',
                'MultiLineString',
                'Polygon',
                'MultiPolygon',
                'Box',
                'GeometryCollection'
            ].includes(value.type)
        ) {
            value = this._format.read(value)
        } else {
            value = null
        }
        if (value) {
            try {
                let g = JSON.parse(this._format.write(value))
                return g.features
            } catch (error) {
                throw '暂不支持的数据格式！'
            }
        }
        throw '暂不支持的数据格式！'
    }
}
